import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  //状态
  state: {
    loading: false
  },
  //状态修改方法
  // 使用store.commit()来调用
  mutations: {
    setloading(state, load) {
      state.loading = load
    }
  },
  getters: {
    isloading:(state)=>{
      return state.loading
    }
  }
})
// 导出
export default store